import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface companyProfileState {
    companyDetails: any[]
}

const initialState : companyProfileState = {
    companyDetails:[]
}

const companyProfileSlice = createSlice({
    name:"companyProfile",
    initialState,
    reducers: {
        setCompanyDetails: (state,action: PayloadAction<any[]>) => {
            state.companyDetails = action.payload;
        },
    },
});

export const { setCompanyDetails } = companyProfileSlice.actions;
export default companyProfileSlice.reducer;